import { render, staticRenderFns } from "./IconOrders.vue?vue&type=template&id=a0ef9634"
import script from "./IconOrders.vue?vue&type=script&lang=ts"
export * from "./IconOrders.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports